<div class="dialog-content-wrapper confirm-dialog">
    <mat-toolbar matDialogTitle class="m-0" style="background-color: white; color: #444">
        <mat-toolbar-row fxLayout=" row " fxLayoutAlign="space-between center " style="justify-content: space-between;">
            <div *ngIf="!hotelGallery.hotel.title " class="dialog-title ">{{ 'Gallery Hotel' }}</div>
            <div *ngIf="hotelGallery.hotel.title " class="dialog-title ">{{ hotelGallery.hotel.title }}</div>
            <button mat-icon-button (click)="dialogRef.close() " aria-label="Close dialog ">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="m-0 text-center pb-10 " style="max-height: 95vh; ">

        <div class="row px-10 pb-20">
            <div class="col-12 col-sm-6">
                <ng-container *ngFor="let image of hotelGallery.gallery; let odd = odd">
                    <img *ngIf="odd" style="width: 100%; height: auto; margin-bottom: 15px;" [src]="getSource(image.URL)">
                </ng-container>
            </div>
            <div class="col-12 col-sm-6">
                <ng-container *ngFor="let image of hotelGallery.gallery; let even = even">
                    <img *ngIf="even" style="width: 100%; height: auto; margin-bottom: 15px;" [src]="getSource(image.URL)">
                </ng-container>
            </div>
        </div>

    </div>
</div>